<template>
	<div class="full">

		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="同步申请" name="supplierupload">
				<div class="pane_container">
					<supplierupload :currentRow="currentRow" :key="'footer_supplieru-pload_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="评级变更" name="levellog">
				<div class="pane_container">
					<levellog :currentRow="currentRow" :key="'footer_levellog_'+key" />
				</div>
			</el-tab-pane>
<!-- 			<el-tab-pane label="积分变更" name="scorelog">
				<div class="pane_container">
					<scorelog :currentRow="currentRow" :key="'footer_scorelog_'+key" />
				</div>
			</el-tab-pane> -->
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import supplierupload from './supplierupload.vue';
	import levellog from './levellog.vue';
	// import scorelog from './scorelog.vue';
	export default {
		props: {
			currentRow: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				activeName: 'supplierupload',
				detailRef: 'footer_' + Math.random(),
				key: Math.random(),
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			reload() {
				this.key = Math.random()
			}
		},
		components: {
			supplierupload,
			levellog,
			// scorelog
		}
	}
</script>